module.exports = __webpack_public_path__ + "img/equipment-08@2x.17615717.png";